module.exports = __webpack_public_path__ + "static/media/vitality_loading.5dd516a9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/aia/vitality_loading.mp4
// module id = 181
// module chunks = 0